import { notification } from "antd";

export const Notification = (type, label, desc) => {
  return notification[type]({
    key: 1,
    message: label,
    description: desc,
  });
};
